module.exports = __webpack_public_path__ + "static/media/patrat.03ea2a0a.png";